import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { Workspace } from 'honeygrid-types'

export const workspacesQueryKey = () => ['workspaces'] as const

export const useWorkspaces = () => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<Workspace[]>({
		queryKey: workspacesQueryKey(),
		queryFn: (): Promise<Workspace[]> => authFetch('workspaces'),
	})
}
